/**
 * 博客 - 正文
 */

//Cookie Common Class
function getCookie(key) {
    var result = document.cookie.match(new RegExp(key + "=([^;]*)"));
    return result != null ? unescape(decodeURI(result[1])) : null;
}
/*加载css*/
var linkObj = document.createElement("link");
linkObj.setAttribute("rel", "stylesheet");
linkObj.setAttribute("type", "text/css");
linkObj.setAttribute("id", "css");
if (getCookie("read_mode") == "night") {
    linkObj.setAttribute("href", "../../css/channel/night.css?v=" + (typeof night_css_version == "undefined" ? "" : night_css_version));
} else {
    linkObj.setAttribute("href", "../../css/channel/day.css?v=" + (typeof day_css_version == "undefined" ? "" : day_css_version));
}
document.getElementsByTagName("head")[0].appendChild(linkObj);
function setCookie(key, value, expireDay) {
    if (expireDay) {
        var date = new Date();
        date.setTime(date.getTime() + expireDay * 24 * 3600 * 1000);
        document.cookie = key + "=" + escape(value) + ";path=/;expires=" + date.toGMTString();
    } else {
        document.cookie = key + "=" + escape(value) + ";path=/";
    }
}

var article_box = document.getElementById("article_box");
var isSmallSize = true;
function setFont() {
    var fontCookie = getCookie("article_fontsize");
    if (fontCookie) {
        if (fontCookie == "19") {
            article_box.style.fontSize = "19px";
            isSmallSize = false;
        }
    }
}
function initNavMenu() {
    navmenu.init({
        opennavmenuid: "setting",
        showchangesize: true,
        defaultSmallSize: isSmallSize,
        clickBigSize: function () {
            article_box.style.fontSize = "19px";
            setCookie("article_fontsize", "19", 365);
        },
        clickSmallSize: function () {
            article_box.style.fontSize = "17px";
            setCookie("article_fontsize", "17", 365);
        }
    });
}

window.onload = function () {
    setFont();
    initNavMenu();
   
    var slideShare = document.getElementById("slideShare");
    var slideHeader = document.getElementById("slideHeader");
    var share_cl = document.getElementById("share-close");
    slideShare.onclick = function () {
        slideHeader.className = "slideLeft";
    };
    share_cl.onclick = function () {
        slideHeader.className = "slideRight";
    };
};
$(window).scroll(function () {
    if ($(window).scrollTop() > $(window).height()) {
        $("#go_top").fadeIn();
    } else {
        $("#go_top").fadeOut();
    }
});
window.weiboOpt = {
    source: "手机东方财富网",
    sourceUrl: "http://wap.eastmoney.com/",
    Appkey: "3050999700",
    RalateUid: "1801487174",
    weibolink: "http://weibo.com/dfcfw"
};
function shareTo(dest) {
    var url = window.shareUrl;
    var cName = "";
    /*sina*/
    var source = weiboOpt.source;
    var sourceUrl = weiboOpt.sourceUrl;
    var sinaAppkey = weiboOpt.Appkey;
    var sinaRalateUid = weiboOpt.RalateUid;

    var title = window.title + "-" + source + "(eastmoney.cn)";

    if (url == null || title == null || url == "" || title == "") {
        alert("错误的链接地址或标题");
        return;
    }
    var shareUrl = "";
    switch (dest.toLowerCase()) {
        case "sina":
            shareUrl = "http://service.weibo.com/share/share.php?url=" + encodeURIComponent(url) + "&appkey=" + sinaAppkey + "&title=" + encodeURIComponent(title) + "&pic=" + encodeURIComponent(pic) + "&ralateUid=" + sinaRalateUid + "&source=" + encodeURIComponent(source) + "&sourceUrl=" + encodeURIComponent(sourceUrl);
            break;
        case "qq":
            shareUrl = "http://v.t.qq.com/share/share.php?url=" + encodeURIComponent(url) + "&appkey=801004939&site=http://wap.eastmoney.com&title=" + encodeURIComponent(title) + "&pic=" + encodeURIComponent(pic);
            break;
        case "qzone":
            shareUrl = "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" + encodeURIComponent(url) + "&appkey=801004939&site=http://wap.eastmoney.com&title=" + encodeURIComponent(title) + "&desc=&summary=&site=http://wap.eastmoney.com";
            break;
    }
    location.href = shareUrl;
}
$('#header_share_qq').click(function (){
	shareTo('qq');
});
$('#header_share_qzone').click(function (){
	shareTo('qzone');
});
$('#header_share_sina').click(function (){
	shareTo('sina');
});
$('#header_share_qq2').click(function (){
	shareTo('qq');
});
$('#header_share_qzone2').click(function (){
	shareTo('qzone');
});
$('#header_share_sina2').click(function (){
	shareTo('sina');
});



//////////////////
// WEBPACK FOOTER
// ./dev/channel/blog_article.js
// module id = 0
// module chunks = 1